import { ModelCollectionBase } from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/Collections";
import { GameModel } from "./GameModel";
import { ModelTable } from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/ModelTable";
import { BlockModel } from "./BlockModel";
import { BlockChainModel } from "./BlockChainModel";


export interface ModelCollection extends ModelCollectionBase {
    game: GameModel,
    blocks: ModelTable<ModelCollection, BlockModel>,
    blockchain: BlockChainModel,
}

export function create_models(): ModelCollection {
    const collection: ModelCollection = {} as ModelCollection;
    return Object.assign(collection, {
        game: new GameModel(collection),
        blocks: new ModelTable(collection, BlockModel),
        blockchain: new BlockChainModel(collection),
    });
}